import { defineComponent as _defineComponent } from 'vue'
import Dialog from "@/components/vuetify-wrappers/Dialog.vue";
import NjBtn from "@/components/vuetify-wrappers/NjButton.vue";
import { ApiService, RouterService, SnackbarService } from "@/services";
import { BriefcaseFolder, VignetteHelpers, VignetteRoutes } from "@/types";
import { computed } from "vue";
import { useBriefcaseStore } from "@/pinia/briefcase";
import { Dictionary } from "vue-router/types/router";
import { useRoute, useRouter } from "vue-router/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteBriefcaseFolderDialog',
  props: {
    isOpen: { type: Boolean },
    folder: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: "close"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isOpen: boolean;
  folder: BriefcaseFolder;
};

const router = useRouter();
const route = useRoute();





const briefcaseStore = useBriefcaseStore();
const currentFolder = computed(
  () => briefcaseStore.folders[briefcaseStore.meta.currentFolderId]
);

const deleteFolder = async () => {
  const response = await ApiService.postBriefcaseFolderDelete(props.folder.id);

  if (response.statusCode === 200) {
    VignetteHelpers.Analytics.push({
      ["event"]: "briefcase-delete-folder",
    });
    SnackbarService.displaySnackbar("Folder deleted.", "primary");

    if (props.folder.id === currentFolder.value.id) {
      navigateToFolder(briefcaseStore.meta.defaultFolderId);
    }
  } else {
    SnackbarService.displaySnackbar("An error occurred. Please try again.");
  }

  emit("close");
};

const navigateToFolder = (folderId: number) => {
  const isSubFolder = folderId !== briefcaseStore.meta.defaultFolderId;
  const params: Dictionary<string> = isSubFolder
    ? { folderId: String(folderId) }
    : {};

  briefcaseStore.meta.currentFolderId = folderId;
  RouterService.navigateByName(
    router,
    isSubFolder ? VignetteRoutes.BriefcaseFolder : VignetteRoutes.Briefcase,
    route.query,
    params
  );
};

return { __sfc: true,router, route, props, emit, briefcaseStore, currentFolder, deleteFolder, navigateToFolder, Dialog, NjBtn }
}

})